/**
 * Utilidades para detectar Smart TVs, dispositivos táctiles y decidir el modo de layout
 */

/**
 * Detecta si el dispositivo es una Smart TV basándose en el User Agent
 */
export const isSmartTV = (): boolean => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent.toLowerCase();

    const tvKeywords = [
        'smart-tv', 'smarttv', 'googletv', 'appletv', 'hbbtv', 'netcast', 'viera',
        'webos', 'tizen', 'crkey', 'roku', 'firetv', 'philipstv', 'sonytv',
        'androidtv', 'google tv', 'android tv', 'playstation', 'xbox'
    ];

    return tvKeywords.some(keyword => ua.includes(keyword));
};

/**
 * Detecta si el dispositivo tiene capacidades táctiles
 */
export const isTouchDevice = (): boolean => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
    return (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        (navigator as any).msMaxTouchPoints > 0
    );
};

/**
 * Determina si se debe forzar el modo desktop basado en las reglas:
 * screenWidth >= 1280 Y (es Smart TV O NO es táctil)
 */
export const shouldForceDesktop = (): boolean => {
    if (typeof window === 'undefined') return false;

    const screenWidth = window.screen.width || window.innerWidth;
    const isLargeScreen = screenWidth >= 1280;
    const isTV = isSmartTV();
    const hasTouch = isTouchDevice();

    // Condición: pantalla grande + (es TV o no es táctil)
    return isLargeScreen && (isTV || !hasTouch);
};
